import { NavLink } from "react-router-dom";
import { useState } from "react";
import { MdDashboard, MdMenu, MdClose, MdSettings } from "react-icons/md";
import { CiLogout } from "react-icons/ci";
import pro from "../../assets/profile.svg";
import { useAuth } from "../../context/useAuth";

export default function Sidebar({ isOpen, setIsOpen }) {
  const { logout } = useAuth();

  const navLinkClasses = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 rounded-[10px] transition-all text-sm font-medium ${
      isActive
        ? "bg-orange-100 text-orange-600 font-semibold"
        : "text-gray-700 hover:bg-orange-50 hover:text-orange-600"
    }`;

  const navItems = [
    { to: "/dashboard", label: "Dashboard", icon: <MdDashboard size={20} /> },
    { to: "/dashboard/orders", label: "Orders" },
    { to: "/dashboard/vendors", label: "Vendors" },
    { to: "/dashboard/riders", label: "Riders" },
    { to: "/dashboard/locations", label: "Locations" },
    { to: "/dashboard/categories", label: "Categories" },
    { to: "/dashboard/products", label: "Products" },
    { to: "/dashboard/users", label: "Users" },
    { to: "/dashboard/notification", label: "Notifications" },
  ];

  return (
    <>
      {/* MOBILE OVERLAY */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* SIDEBAR */}
      <aside
        className={`
          fixed top-0 left-0 h-screen bg-white p-6 flex flex-col shadow-lg border-r border-gray-200 z-50
          transition-transform duration-300 ease-in-out w-[280px]
          ${isOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0
        `}
      >
        <div className="flex-1 overflow-y-auto">
          <div className="mb-8">
            <h1 className="text-orange-500 font-bold text-2xl">Sweetplate Admin</h1>
          </div>

          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={navLinkClasses}
                onClick={() => setIsOpen(false)}
              >
                {item.icon || <div className="w-5" />}
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="pt-4 mt-4 border-t border-gray-100 flex flex-col gap-4">
          <NavLink
            to="/dashboard/settings"
            className={navLinkClasses}
            onClick={() => setIsOpen(false)}
          >
            <MdSettings size={20} />
            <span>System Settings</span>
          </NavLink>

          <div className="flex items-center gap-3 bg-gray-50 p-3 rounded-xl">
            <div className="h-10 w-10 rounded-full overflow-hidden border border-gray-300 shrink-0">
              <img src={pro} alt="profile" className="h-full w-full object-cover" />
            </div>
            <div className="flex-1 min-w-0">
              <h1 className="text-sm font-semibold text-gray-800 truncate">Admin</h1>
              <p className="text-[10px] text-gray-500 truncate">admin@sweetplate.org</p>
            </div>
            <button
              onClick={logout}
              className="p-2 hover:bg-red-50 rounded-lg transition-colors group"
              title="Logout"
            >
              <CiLogout className="text-red-600 group-hover:text-red-800" size={22} />
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}
